<h1 matDialogTitle>
	<div class="flex items-center">
		<div>{{ "reports.export" | translate }}</div>
		<div class="flex-auto"></div>
		<div class="flex items-center space-x-2">
			<button
				[disabled]="closeDisabled"
				mat-icon-button
				matDialogClose
				tabindex="-1"
			>
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>
</h1>
<mat-dialog-content cdkTrapFocus>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="this.group"
		class="mb-3"
	>
		<div class="flex flex-col items-stretch justify-start gap-2">
			<div class="flex flex-col gap-1">
				<div class="mat-typography mat-hint">{{ "reports.exports.type" | translate }}</div>
				<mat-radio-group
					class="file-type-group grid grid-cols-1 gap-2 mb-4 sm:grid-cols-2"
					formControlName="fileType"
				>
					<mat-radio-button
						[class.file-type-option--active]="group.value.fileType === fileType.value"
						[value]="fileType.value"
						*ngFor="let fileType of fileTypeOptions"
						class="file-type-option"
					>
						<div class="file-type-option__content">
							<div class="file-type-option__left">
								<div class="file-type-option__icon-wrap">
									<mat-icon class="file-type-option__icon">{{ fileType.icon }}</mat-icon>
								</div>
								<div class="flex flex-col leading-tight">
									<span class="font-medium">{{ fileType.title }}</span>
									<span class="mat-hint text-xs">{{ fileType.description }}</span>
								</div>
							</div>
							<div
								*ngIf="group.value.fileType === fileType.value"
								class="file-type-option__active-indicator"
							>
								<mat-icon>check</mat-icon>
							</div>
						</div>
					</mat-radio-button>
				</mat-radio-group>
			</div>

			<mat-form-field appearance="fill">
				<mat-label>{{ "reports.export" | translate }}</mat-label>
				<mat-select formControlName="exportType">
					<mat-option
						[value]="item.name"
						*ngFor="let item of filteredExportTypes$.value$ | async"
					>
						<div>
							<span>{{ item.name | translate }}</span>
							@if (item.name === "reports.exports.excel-download-simple") {
							<span
								*isDev
								class="text-xs text-muted"
							>
								(Dev only)
							</span>
							}
						</div>
					</mat-option>
				</mat-select>
				<mat-error *ngIf="getErrorObservable('exportType', 'reports.exports.type') | async as error">
					{{ error.content | translate: error.args || {} }}
				</mat-error>
			</mat-form-field>

			<div class="flex flex-col">
				<div class="rounded-lg mat-bg flex flex-col px-3.5 py-3 gap-2">
					<div class="flex flex-col gap-2 lg:flex-row lg:items-center">
						<div class="flex flex-col flex-auto">
							<div class="text-base leading-tight font-semibold">
								{{ "reports.export-columns.label" | translate }}
								({{ (selectedExportColumns$.value$ | async) | length }}/{{ exportColumns.length }}
								{{ "reports.export-columns.selected" | translate }})
							</div>
							<div class="mat-typography mat-hint">
								{{ "reports.export-columns.orderNotice" | translate }}
							</div>
						</div>
						<div class="flex flex-wrap items-center justify-end gap-1 flex-shrink-0">
							<button
								(click)="selectAllColumns()"
								class="!min-w-0 !h-7 !px-2.5 !leading-7"
								mat-button
								type="button"
							>
								{{ "reports.export-columns.selectAll" | translate }}
							</button>
							<div class="h-4 w-px mat-bg-5"></div>
							<button
								(click)="clearSelectedColumns()"
								class="!min-w-0 !h-7 !px-2.5 !leading-7"
								mat-button
								type="button"
							>
								{{ "reports.export-columns.clearSelection" | translate }}
							</button>
						</div>
					</div>
					<div class="h-px mat-bg-5"></div>
					<div
						class="columns-1 gap-x-1 pt-2 pb-4 md:columns-2 lg:columns-3"
						formGroupName="columns"
					>
						<ng-container *ngFor="let groupColumns of groupedExportColumns">
							<div class="mb-4 break-inside-avoid flex flex-col">
								<div class="mb-1 text-sm font-semibold">{{ groupColumns.nameKey | translate }}</div>
								<ng-container *ngFor="let col of groupColumns.columns">
									<mat-checkbox
										[formControlName]="col"
										class="mat-checkbox-truncate mat-checkbox-flex"
										color="primary"
									>
										<span class="truncate">{{ "reports.export-column." + col | translate }}</span>
									</mat-checkbox>
								</ng-container>
							</div>
						</ng-container>
					</div>
					<div class="h-px mat-bg-5"></div>
					<div class="flex py-1 flex-shrink-0">
						<div class="flex gap-x-2 text-muted items-center">
							<mat-icon inline>info</mat-icon>
							<span class="text-sm leading-none">{{
								"reports.export-columns.savedAutomatically" | translate
							}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</form>
</mat-dialog-content>
<mat-dialog-actions class="flex lg:justify-end lg:flex-row">
	<ng-container
		*ngTemplateOutlet="
      !isLoading ? submitButton : submitWaitButton;
      context: { disabled: group.invalid || group.disabled }
    "
	></ng-container>
</mat-dialog-actions>
<ng-template
	#submitButton
	let-disabled="disabled"
>
	<button
		(click)="close()"
		[disabled]="disabled"
		class="!px-6 !h-10 !rounded-lg"
		mat-stroked-button
	>
		{{ "utils.cancel" | translate }}
	</button>
	<button
		(click)="submit()"
		[disabled]="disabled || closeDisabled"
		class="!px-6 !h-10 !rounded-lg lg:!w-[168px]"
		color="primary"
		mat-flat-button
	>
		{{ "reports.export-download" | translate }}
	</button>
</ng-template>
<ng-template #submitWaitButton>
	<button
		[disabled]="true"
		class="!px-6 !h-10 !rounded-lg lg:!w-[168px]"
		color="primary"
		mat-flat-button
	>
		<div class="flex items-center justify-center space-x-2">
			<mat-spinner
				[diameter]="16"
				[strokeWidth]="2"
				mode="indeterminate"
			></mat-spinner>
			<span>{{ "reports.export-downloading" | translate }}</span>
			<span *ngIf="(progress.value$ | async)?.progress as p">{{ p | percent: 1 : 2 }}</span>
		</div>
	</button>
</ng-template>
